module.exports = __webpack_public_path__ + "static/media/farewell_logo.87312b6e.png";